import React, { useEffect, useState, useRef } from 'react';
import styled, { css, createGlobalStyle } from 'styled-components';
import Logo from './styled/Logo';
import Input from './styled/Input';
import Button from './styled/Button';
import { useTranslation } from 'react-i18next';
import ErrorList from './styled/ErrorList';
import DropdownList from './styled/DropdownList';
import countries from 'i18n-iso-countries';

import { useDispatch } from 'react-redux';
import { initializeForm } from '../../modules/auth';
import ValidateDiv from '../../components/auth/styled/ValidateText';
import { getIpInfo } from '../../lib/api/app';
import { registerCountryLocale } from '../../lib/countryLocales';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import AddressAutocomplete from './AddressAutocomplete';

const PhoneInputCustomStyle = createGlobalStyle`
  .react-tel-input .flag-dropdown {
    border: 1px solid rgb(238, 239, 240) !important;
    background: none !important;
  }
`;

const Container = styled.div`
  .validateCss {
    margin-top: 4px;
    margin-bottom: 8px;
  }
  div {
    font-family: 'Source Sans Pro';
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
  }
  .ContentContainer {
    display: flex;
    width: 100%;
    align-items: center;
    justify-content: center;
  }

  .Content {
    display: flex;
    flex-direction: column;
    width: 448px;
    /* margin-left: 496px; */
  }
`;

const Title = styled.div`
  width: 328px;
  height: 32px;
  margin-left: 16px;
  ${(props) =>
    props.error
      ? css`
          margin-top: 0px;
        `
      : css`
          margin-top: 102px;
        `}
  font-size: 25px;
  font-weight: 600;
  color: #59616a;
`;

const SubTitle = styled.div`
  width: 500px;
  height: 24px;
  margin: 16px 0 24px 16px;
  font-size: 15px;
  line-height: 1.6;
  color: #969ba1;
`;

const Avatar = styled.div`
  display: flex;
  min-width: 424px;
`;

const P = styled.p`
  display: inline-block;
  width: 344px;
  height: 48px;
  margin-top: 16px;
  margin-left: 16px;
  font-size: 15px;
  line-height: 1.6;
  color: #59616a;
  display: flex;
  align-items: center;

  font-family: 'Source Sans Pro';
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  letter-spacing: normal;
`;

const SocialSignupForm = ({
  form,
  language,
  onChange,
  onSelect,
  onSubmit,
  error,
  onFocusOut,
  onVerifyPhoneClick,
  isPhoneVerified,
  isLoaded,
  isHCloud,
}) => {
  const { t, i18n } = useTranslation();
  const dispatch = useDispatch();

  const countryLocale = registerCountryLocale(language);

  const [countryCode, setCountryCode] = useState();
  const countryRef = useRef(null);

  useEffect(() => {
    window.history.pushState(null, null, window.location.pathname);

    const ipInfo = async () => {
      const res = await getIpInfo();
      if (res.data) setCountryCode(res.data.country_code);
    };
    ipInfo();

    return () => {
      dispatch(initializeForm('authError'));
    };
  }, []);

  useEffect(() => {
    if (countryCode) {
      const country_name = countries.getName(countryCode, countryLocale);
      countryRef.current?.setValue(country_name);
      onSelect(countryCode, 'country');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [countryCode]);

  return (
    <Container>
      <PhoneInputCustomStyle />
      <Logo />
      <div className="ContentContainer">
        <div className="Content">
          <ErrorList error={error}></ErrorList>
          <Title style={{ fontWeight: '600' }} error={error}>
            {t('Create New Account')}
          </Title>
          <SubTitle>
            {t('Enter your details below and click “Create Account”.')}
            <br></br>
            {t('*All fields are mandatory.')}
          </SubTitle>

          <form onSubmit={onSubmit}>
            <Input
              type="email"
              name="username"
              margin="0"
              value={form.username}
              tabIndex={1}
              required
              readOnly={true}
              bgkColor={'#f5f6f6'}
            />
            <Input
              type="text"
              name="first_name"
              margin="0"
              value={form.first_name}
              tabIndex={4}
              required
              readOnly={true}
              bgkColor={'#f5f6f6'}
            />
            <DropdownList
              name="role"
              width="448px"
              height="48px"
              placeholder={t('Institution Type') + '*'}
              margin="8px 0 0 0"
              img_margin="12px 12px 12px 0"
              search={true}
              items={['Dental Clinic', 'Dental Lab', 'Dealer', 'Other']}
              onSelect={onSelect}
              zIndex={2}
              tabIndex={6}
              required
            />
            <ValidateDiv name="roleValidate"></ValidateDiv>
            <Input
              name="institution"
              margin="0"
              placeholder={t('Institution Name')}
              value={form.institution}
              onChange={onChange}
              maxLength={100}
              tabIndex={7}
            />
            <DropdownList
              name="country"
              width="448px"
              height="48px"
              maxHeight="216px"
              placeholder={t('Country') + '*'}
              defaultValue={countries.getName(countryCode, countryLocale)}
              margin="8px 0 0 0"
              img_margin="12px 12px 12px 0"
              search={true}
              items={Object.fromEntries(
                Object.entries(
                  countries.getNames(countryLocale, { select: 'official' }),
                ).sort(function ([, a], [, b]) {
                  return a.localeCompare(b);
                }),
              )}
              // itmes={countries.getNames(language, { select: 'official' })}
              onSelect={onSelect}
              zIndex={1}
              tabIndex={8}
              required
              ref={countryRef}
            />
            <ValidateDiv name="countryValidate"></ValidateDiv>
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                width: '448px',
                justifyContent: 'space-between',
              }}
            >
              <PhoneInput
                country={countryCode ? countryCode.toLowerCase() : 'us'}
                value={form.phone}
                onChange={(value) => {
                  onChange({
                    target: {
                      name: 'phone',
                      value: value.startsWith('+') ? value : `+${value}`,
                    },
                  });
                }}
                inputStyle={{
                  width: isHCloud ? '348px' : '448px',
                  height: '48px',
                  border: '1px solid #eeeff0',
                  background: '#fff',
                  borderRadius: '5px',
                  fontSize: '14px',
                  color: '#59616a',
                }}
                disabled={isPhoneVerified}
                enableSearch
              />
              {isHCloud && (
                <Button
                  type="button"
                  width="100%"
                  height="48px"
                  margin="0"
                  onClick={onVerifyPhoneClick}
                  disabled={isPhoneVerified}
                  style={{ pointerEvents: isPhoneVerified ? 'none' : 'auto' }}
                >
                  {isPhoneVerified ? t('Verified') : t('Verify')}
                </Button>
              )}
            </div>
            {isLoaded ? (
              <AddressAutocomplete
                value={form.address}
                onChange={onChange}
                isTabletOrDesktop={true}
              />
            ) : (
              <Input
                as="textarea"
                style={{ resize: 'none', overflow: 'hidden' }}
                name="address"
                height="66px"
                margin="0"
                padding="14px 15px 14px 15px"
                placeholder={t('Address')}
                value={form.address}
                onChange={onChange}
                tabIndex={10}
                maxLength={200}
              />
            )}
            <Button
              data-action="submit"
              margin="24px 0 224px 0"
              tabIndex={12}
              disabled={isHCloud && !isPhoneVerified}
            >
              {t('Activate').toUpperCase()}
            </Button>
          </form>
        </div>
      </div>
    </Container>
  );
};

export default React.memo(SocialSignupForm);
